import React from 'react';

type FormFooterProps = { children: React.ReactNode };

const formFooter = ({ children }: FormFooterProps) => {
	return <div className="vtex-login-2-x-formFooter formFooter bt b--muted-4 pt4 flex mt3">{children}</div>;
};

export default formFooter;
